import { Routes, Route, Link, useLocation } from 'react-router-dom'
import { Settings } from 'lucide-react'
import { AuthProvider } from './contexts/AuthContext'
import HomePage from './pages/HomePage'
import ChecklistPage from './pages/ChecklistPage'
import DatabasePage from './pages/DatabasePage'
import AdminPage from './pages/AdminPage'

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  const location = useLocation()
  const active = location.pathname === to
  return (
    <Link
      to={to}
      className={`px-4 py-2 rounded-lg font-medium transition-colors ${
        active ? 'bg-brand-100 text-brand-700' : 'text-gray-600 hover:bg-gray-100'
      }`}
    >
      {children}
    </Link>
  )
}

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen flex flex-col">
        <nav className="bg-white border-b shadow-sm sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <Link to="/" className="flex items-center gap-2">
                <img src="/logo_EV_CHECK.png" alt="EV-Checklist" className="h-9 w-auto" />
              </Link>
              <div className="flex gap-2">
                <NavLink to="/">Home</NavLink>
                <NavLink to="/checklist">Submit / Modify</NavLink>
                <NavLink to="/database">Database</NavLink>
                <Link
                  to="/admin"
                  title="Admin"
                  className="ml-2 rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
                >
                  <Settings className="h-5 w-5" />
                </Link>
              </div>
            </div>
          </div>
        </nav>
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/checklist" element={<ChecklistPage />} />
            <Route path="/database" element={<DatabasePage />} />
            <Route path="/admin/*" element={<AdminPage />} />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  )
}

export default App
